import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LogCodes } from 'generated/graphql-types';
import { accountSettingsRoute } from 'src/app/app-routing.module';
import { LogRegisterListItem } from 'src/app/pages/system-log-register/models/system-log-register-results.model';
import { AppConfigService } from '../../app-config/app-config-service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-call-log-dialog',
    styleUrls: ['./call-log-dialog.component.scss'],
    templateUrl: './call-log-dialog.component.html',
    standalone: false
})
export class CallLogDialogComponent {
   callLogs: LogRegisterListItem;

   columns: string[];

   isSystemUser: boolean;

   LogCodes = LogCodes;

   constructor(
      private dialogRef: MatDialogRef<CallLogDialogComponent>,
      @Inject(MAT_DIALOG_DATA) private data: any,
      private datePipe: DatePipe,
      private appConfig: AppConfigService
   ) {
      this.callLogs = data.callLogs;
      this.isSystemUser = data.isSystemUser;

      this.columns = ['DateTime', 'Message', 'Severity', 'Type', 'Area'];
   }

   onCloseClick(): void {
      this.dialogRef.close();
   }

   getRouterLink(id: number) {
      return `/${accountSettingsRoute}/${id}`;
   }

   openLink(callLog: LogRegisterListItem) {
      const namespace = callLog.message?.match(/(?<=\/)(.*?)(?= successful)/);
      if (namespace && callLog.createUserDate) {
         const startTime: number = new Date(callLog.createUserDate).getTime() - 5 * 60 * 1000;
         const startDate = this.datePipe.transform(new Date(startTime), 'yyyy-MM-ddTHH:mm:ss.SSSZ');
         const endDate = this.datePipe.transform(callLog.createUserDate, 'yyyy-MM-ddTHH:mm:ss.SSSZ');
         const link = `https://ndt-graylog.lcs.com/search?q=source%3A${namespace[0]}&rangetype=absolute&from=${startDate}&to=${endDate}`;

         window.open(link, '_blank');
      }
   }
}
